import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      minWidth: 300,
      background: '#F5F8FA',
      borderRadius: 20,
      maxHeight: 35,
      height: '100%',
      '& div': {
        maxHeight: 35,
        '& fieldset': {
          border: 'none',
        },
        '&:focus-within': {
          '& fieldset': {
            border: 'solid 1px #249eb2',
            borderRadius: 20,
          },
        },
      },
    },
    active: {
      background: '#F5F8FA',
    },
  }),
);

export default useStyles;
